export enum ReportState {
  complete = "complete",
  generating = "generating",
  failed = "failed",
}
